export default __webpack_public_path__ + "static/media/arrow.47f831dc.svg";